define('SageDotCom/DataLayer/Global/imageButtons',['jquery',
    'SageDotCom/DataLayer/tealium',
    'SageDotCom/DataLayer/Events/exitLinkClick',
    'SageDotCom/DataLayer/Events/buttonClick',
    'SageDotCom/DataLayer/Events/fileDownload',
    'SageDotCom/DataLayer/Util/urlHelper'],
    function ($, analytics, exitLinkEvent, buttonClickEvent, fileDownloadEvent, urlHelper) {
        function globalButtonTracking() { }

        globalButtonTracking.prototype.initialize = function initialize() {
            $(".score-image-button:not([data-xpr-state], [data-tracking])").not("footer .score-image-button").each(function (key, value) {

                // derive label based on image name
                var label = 'Image Button: ';
                var image = $("img", value);
                if (image) {
                    var imageTest = urlHelper.isFile(image.attr('src'));
                    if (imageTest.isFile === true) {
                        label += imageTest.fileName;
                    }
                }

                // internal URL if hostname is blank or matches current browser URL
                if (!value.hostname || !value.hostname.length || location.hostname.toLowerCase() === value.hostname.toLowerCase()) {
                    // handle file download vs internal link click
                    var fileTester = urlHelper.isFile(value.href);

                    if (fileTester.isFile === true && fileTester.fileName) {
                        $(value).on('click', function (event) {
                            var data = fileDownloadEvent.GenerateEventMetadata(event.currentTarget, fileTester.fileName, label);
                            analytics.event(data);
                        });
                        $(value).attr('data-tracking', fileDownloadEvent.getName());
                    } else {
                        $(value).on('click', function (event) {
                            var data = buttonClickEvent.GenerateEventMetadata(event.currentTarget, label);
                            analytics.event(data);
                        });
                        $(value).attr('data-tracking', buttonClickEvent.getName());
                    }
                } else { // external URL
                    $(value).on('click', function (event) {
                        var data = exitLinkEvent.GenerateEventMetadata(event.currentTarget, label);
                        analytics.event(data);
                    });

                    $(value).attr('data-tracking', exitLinkEvent.getName());
                }
            });
        }

        return new globalButtonTracking();
    });
